import { Typography,Grid2,Box } from "@mui/material";
import pic from "../../../../ui-utils/latestPics/EquityAcc.svg"
import Styles from "./Web.module.css"
import { AnimationOnScroll } from "react-animation-on-scroll";
import { useLanguage } from "../../../../Context/LangContext";
import en from "../../../../i18n/English/Trade Invest/account.json";
import hi from "../../../../i18n/Hindi/Trade Invest/account.json";
import kn from "../../../../i18n/Kannada/Trade Invest/account.json";
import ma from "../../../../i18n/Marathi/Trade Invest/account.json";
import gu from "../../../../i18n/Gujarati/Trade Invest/account.json";
export default function AccountWeb(){
    const { language } = useLanguage();
    const translations = { en, hi, kn,ma,gu };
    const t = translations[language];
    return(
        <>
        <Box className={Styles.outerBox}>
                <AnimationOnScroll animateIn="animate__fadeInDown"
                    animateOnce={true}
                    className={Styles.customFadeInLeft}>
                    {/* <Typography className={Styles.heading} style={{ fontWeight: 600 }}>

                    {t.heading}

           </Typography> */}

                    <div className={Styles.headingContainer}>
                        <div className={Styles.gradientBackground}></div>
                        <Typography className={Styles.heading}>
                            {t.heading}
                        </Typography>
                    </div>
           <Typography className={Styles.subtxt}>
                    {/* You require a Demat (dematerialized) account to engage in equity trading in India. You can hold shares of companies in a dematerialized manner and buy and sell them using this Demat account. */}
                        {t.subtxt}
           </Typography>
           </AnimationOnScroll>
           <Grid2 className={Styles.innerCard}>
                    <AnimationOnScroll animateIn="animate__fadeInLeft"
                        animateOnce={true}
                        className={Styles.customFadeInLeft}>
                    <Grid2 >
                        <Typography className={Styles.innertxt1}>
                            {/* Once you’ve opened your Demat and trading account, we’ll link it to your savings bank account for easy fund transfers—just give us the green light! With our fully digital process, you can get your tradeboss account set up in just 7 minutes!* */}
                            {t.innerText1}
                        </Typography>

                        <Typography className={Styles.innertxt1} sx={{paddingTop:"20px"}}>
                            {/* So, why do you need a Demat account? It keeps all your securities in a neat, paperless format—totally digital! And what about a trading account? That’s how you buy and sell securities on the stock exchange. Plus, when you open your account, you’ll get your own unique Trading ID! */}
                        {t.innerText2}
                        </Typography>

                   </Grid2>
                   </AnimationOnScroll>


                         <img src={pic}  alt="equity" className={Styles.pic}/>

                </Grid2>
        </Box>
        </>
    )
}